module.exports = __webpack_public_path__ + "img/5.608da2d4.svg";